import React from 'react';
import { IconSvgProps } from '@models/common';

const Microphone: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#microphone-clip)'>
        <path
          d='M5.11184 11.084C5.11184 10.4544 5.62247 9.94375 6.25208 9.94375C6.88168 9.94375 7.39231 10.4544 7.39231 11.084C7.39248 13.9969 9.75394 16.3586 12.6669 16.3586C15.5798 16.3585 17.9414 13.9968 17.9415 11.084C17.9415 10.4544 18.4522 9.94375 19.0818 9.94375C19.7111 9.94401 20.2208 10.4545 20.2208 11.084C20.2207 14.8684 17.4382 18.0025 13.8072 18.5523V20.0242H16.3325C16.9618 20.0244 17.4714 20.534 17.4716 21.1633C17.4716 21.7928 16.962 22.3033 16.3325 22.3035H9.00129C8.37169 22.3035 7.86106 21.7929 7.86106 21.1633C7.86132 20.5339 8.37185 20.0242 9.00129 20.0242H11.5267V18.5523C7.89543 18.0027 5.112 14.8686 5.11184 11.084ZM14.2759 5.58555C14.2759 4.69694 13.5555 3.97669 12.6669 3.97656C11.7782 3.97656 11.0579 4.69686 11.0579 5.58555V11.084C11.0581 11.9725 11.7783 12.693 12.6669 12.693C13.5554 12.6928 14.2757 11.9724 14.2759 11.084V5.58555ZM16.5564 11.084C16.5562 13.2317 14.8146 14.9721 12.6669 14.9723C10.5191 14.9723 8.77764 13.2317 8.77747 11.084V5.58555C8.77747 3.43765 10.519 1.69609 12.6669 1.69609C14.8147 1.69623 16.5564 3.43773 16.5564 5.58555V11.084Z'
          fill='currentColor'
        />
        <path
          d='M21.9879 17.2825C22.0418 17.1368 22.2482 17.1368 22.3021 17.2825L22.842 18.7418C22.8504 18.7644 22.8636 18.785 22.8806 18.8021C22.8977 18.8192 22.9182 18.8324 22.9409 18.8408L24.4002 19.3807C24.5459 19.4346 24.5459 19.641 24.4002 19.6949L22.941 20.2348C22.9184 20.2432 22.8978 20.2564 22.8807 20.2734C22.8636 20.2905 22.8504 20.311 22.842 20.3337L22.3021 21.7929C22.2482 21.9388 22.0418 21.9388 21.9879 21.7929L21.448 20.3338C21.4396 20.3112 21.4264 20.2906 21.4094 20.2735C21.3923 20.2564 21.3718 20.2432 21.3492 20.2348L19.8898 19.6949C19.7441 19.641 19.7441 19.4346 19.8898 19.3807L21.349 18.8408C21.3716 18.8324 21.3922 18.8192 21.4093 18.8022C21.4264 18.7851 21.4396 18.7646 21.448 18.7419L21.9879 17.2825Z'
          fill='currentColor'
        />
        <path
          d='M3.76439 1.11344C3.84007 0.908964 4.12962 0.908964 4.2053 1.11344L4.96302 3.16124C4.97476 3.19302 4.99323 3.22189 5.01716 3.24586C5.0411 3.26983 5.06993 3.28835 5.10169 3.30014L7.14971 4.05787C7.35418 4.13355 7.35418 4.42311 7.14971 4.49879L5.10192 5.25652C5.07015 5.26826 5.04128 5.28673 5.01731 5.31066C4.99333 5.33459 4.97481 5.36343 4.96302 5.39519L4.2053 7.44299C4.12962 7.6477 3.84007 7.6477 3.76439 7.44299L3.00666 5.39542C2.99493 5.36364 2.97646 5.33478 2.95253 5.3108C2.92859 5.28683 2.89976 5.26831 2.868 5.25652L0.819981 4.49879C0.615508 4.42311 0.615508 4.13355 0.819981 4.05787L2.86776 3.30014C2.89954 3.28841 2.92841 3.26994 2.95238 3.246C2.97636 3.22207 2.99487 3.19324 3.00666 3.16148L3.76439 1.11344Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='microphone-clip'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(0.666626)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Microphone;
